var _defs, _clipPath, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloud1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "399.741 266.821 673.786 179.062",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsvectornator: "http://vectornator.io",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "cloud1"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 179.062,
    width: 673.786,
    x: 399.741,
    y: 266.821
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cloud1)",
    id: "Layer",
    vectornatorlayername: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M892.871 383.68L892.871 383.68C892.871 377.049 898.247 371.673 904.878 371.673L934.68 371.673C947.984 371.673 958.769 360.888 958.769 347.584L958.769 347.584C958.769 334.28 947.984 323.495 934.68 323.495L782.012 323.495C775.38 323.495 770.005 318.119 770.005 311.488L770.005 311.488C770.005 304.857 775.381 299.481 782.012 299.481L846.157 299.481C855.176 299.481 862.487 292.17 862.487 283.151L862.487 283.151C862.487 274.132 855.176 266.821 846.157 266.821L650.252 266.821C641.233 266.821 633.922 274.132 633.922 283.151L633.922 283.151C633.922 292.17 641.233 299.481 650.252 299.481L687.353 299.481C693.984 299.481 699.36 304.857 699.36 311.488L699.36 311.488C699.36 318.119 693.984 323.495 687.353 323.495L492.483 323.495C479.179 323.495 468.395 334.28 468.395 347.584L468.395 347.584C468.395 360.888 479.18 371.673 492.483 371.673L561.961 371.673C571.364 371.673 578.987 379.296 578.987 388.699L578.987 388.699C578.987 398.102 571.364 405.725 561.961 405.725L419.82 405.725C408.731 405.725 399.741 414.715 399.741 425.804L399.741 425.804C399.741 436.893 408.731 445.882 419.82 445.882L673.606 445.882C684.695 445.882 693.685 436.892 693.685 425.804L693.685 425.804C693.685 414.715 684.695 405.725 673.606 405.725L666.66 405.725C657.257 405.725 649.634 398.102 649.634 388.699L649.634 388.699C649.634 379.296 657.257 371.673 666.66 371.673L810.219 371.673C816.85 371.673 822.226 377.049 822.226 383.68L822.226 383.68C822.226 390.312 816.85 395.687 810.219 395.687L805.242 395.687C791.381 395.687 780.144 406.924 780.144 420.785L780.144 420.785C780.144 434.646 791.381 445.883 805.242 445.883L1048.43 445.883C1062.29 445.883 1073.53 434.646 1073.53 420.785L1073.53 420.785C1073.53 406.924 1062.29 395.687 1048.43 395.687L904.879 395.687C898.247 395.687 892.871 390.311 892.871 383.68Z",
    fill: "#a9b3c1",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud1);
export default __webpack_public_path__ + "static/media/Cloud1.001fcdda9f6cb96f8a534b56e9ce1234.svg";
export { ForwardRef as ReactComponent };